"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useRealTimeChatCoordinator: ()=>useRealTimeChatCoordinator
});
const external_react_namespaceObject = require("react");
const external_uuid_namespaceObject = require("uuid");
const pennyBroadcast_js_namespaceObject = require("../utils/pennyBroadcast.js");
var pennyBroadcast_js_default = /*#__PURE__*/ __webpack_require__.n(pennyBroadcast_js_namespaceObject);
const external_useRealTimeAudioPlayer_js_namespaceObject = require("./useRealTimeAudioPlayer.js");
const external_useRealTimeAudioRecorder_js_namespaceObject = require("./useRealTimeAudioRecorder.js");
const external_useRealTimeWebSocket_js_namespaceObject = require("./useRealTimeWebSocket.js");
const ContextHandler_js_namespaceObject = require("../components/Realtime/PlacementContextHandler/ContextHandler.js");
function useRealTimeChatCoordinator({ locale, realtimeContext, analytics, baseUrl, onLoadingChange, onOpenStateChange, pennysid, requestFrom, isCustomVoice = false }) {
    const [messages, setMessages] = (0, external_react_namespaceObject.useState)([]);
    const [marker, setMarker] = (0, external_react_namespaceObject.useState)(null);
    const [isActive, setIsActive] = (0, external_react_namespaceObject.useState)(false);
    const [isInitializing, setIsInitializing] = (0, external_react_namespaceObject.useState)(true);
    const chatMessagesRef = (0, external_react_namespaceObject.useRef)([]);
    const wsRef = (0, external_react_namespaceObject.useRef)(null);
    const playAudioRef = (0, external_react_namespaceObject.useRef)();
    const instanceRef = (0, external_react_namespaceObject.useRef)((0, external_uuid_namespaceObject.v4)());
    const { playAudio, clearQueue } = (0, external_useRealTimeAudioPlayer_js_namespaceObject.useRealTimeAudioPlayer)(analytics);
    (0, external_react_namespaceObject.useEffect)(()=>{
        playAudioRef.current = playAudio;
    }, [
        playAudio
    ]);
    const handleMessage = (0, external_react_namespaceObject.useCallback)((message)=>{
        switch(message.type){
            case 'session.created':
                (0, ContextHandler_js_namespaceObject.placementContextHandler)(wsRef, realtimeContext);
                break;
            case 'realtime_marker':
                setMarker(message.marker);
                break;
            case 'conversation.item.deleted':
                setMessages((prev)=>prev.filter((item)=>item.item_id !== message.item_id));
                break;
            case 'realtime_halt_playback':
                localStorage.setItem('isAudioInterrupted', 'yes');
                clearQueue();
                break;
            case 'response.audio.delta':
                localStorage.setItem('isAudioInterrupted', 'no');
                playAudioRef.current?.(message.delta);
                break;
            case 'input_audio_buffer.speech_started':
                localStorage.setItem('isAudioInterrupted', 'yes');
                break;
            case "conversation.item.input_audio_transcription.completed":
                if (message.transcript) setMessages((prev)=>[
                        ...prev,
                        {
                            role: 'user',
                            content: message.transcript
                        }
                    ]);
                break;
            case "response.audio_transcript.done":
                onLoadingChange?.(false);
                setMessages((prev)=>[
                        ...prev,
                        {
                            role: 'assistant',
                            content: message.transcript,
                            item_id: message.item_id
                        }
                    ]);
                break;
        }
    }, [
        onLoadingChange
    ]);
    const { isConnected, sendMessage } = (0, external_useRealTimeWebSocket_js_namespaceObject.useRealTimeWebSocket)({
        url: baseUrl,
        locale,
        realtimeContext,
        onMessage: handleMessage,
        analytics,
        pennysid,
        requestFrom,
        isCustomVoice
    });
    const handleAudioChunk = (0, external_react_namespaceObject.useCallback)((base64AudioData)=>{
        wsRef.current?.sendMessage({
            type: 'input_audio_buffer.append',
            audio: base64AudioData
        });
    }, []);
    const { isRecording, isMuted, mediaStream, startRecording, stopRecording, toggleMute } = (0, external_useRealTimeAudioRecorder_js_namespaceObject.useRealTimeAudioRecorder)(handleAudioChunk, analytics);
    (0, external_react_namespaceObject.useEffect)(()=>{
        wsRef.current = {
            sendMessage
        };
    }, [
        sendMessage
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        chatMessagesRef.current = messages;
    }, [
        messages
    ]);
    const commit = (0, external_react_namespaceObject.useCallback)(()=>{
        wsRef.current?.sendMessage({
            type: 'input_audio_buffer.commit'
        });
    }, []);
    const startChat = (0, external_react_namespaceObject.useCallback)(async ()=>{
        if (isActive || !isConnected) return;
        try {
            await startRecording();
            setIsActive(true);
            onLoadingChange?.(true);
        } catch (error) {
            analytics.logError({
                loggedFrom: 'useRealTimeChatCoordinator.startChat',
                message: 'Failed to start chat',
                error
            });
        }
    }, [
        isActive,
        isConnected,
        startRecording,
        onLoadingChange,
        analytics
    ]);
    const stopChat = (0, external_react_namespaceObject.useCallback)(()=>{
        if (!isActive) return;
        stopRecording();
        localStorage.setItem('isAudioInterrupted', 'yes');
        clearQueue();
        setIsActive(false);
        onLoadingChange?.(false);
    }, [
        isActive,
        stopRecording,
        clearQueue,
        commit,
        onLoadingChange
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (isConnected && isInitializing) {
            startChat();
            setIsInitializing(false);
        }
    }, [
        isConnected,
        isInitializing,
        startChat
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>()=>{
            if (isActive) stopChat();
        }, [
        stopChat
    ]);
    const pennyBroadcastListener = (0, external_react_namespaceObject.useCallback)((event)=>{
        if (event.data.type === pennyBroadcast_js_namespaceObject.BroadcastType.NEW_REALTIME_VOICE_INSTANCE && event.data.instanceId !== instanceRef.current) {
            setIsActive(false);
            clearQueue();
            stopChat();
            onOpenStateChange(false);
        }
    }, []);
    (0, pennyBroadcast_js_namespaceObject.usePennySubscriber)(pennyBroadcastListener);
    (0, external_react_namespaceObject.useEffect)(()=>{
        pennyBroadcast_js_default()({
            type: pennyBroadcast_js_namespaceObject.BroadcastType.NEW_REALTIME_VOICE_INSTANCE,
            instanceId: instanceRef.current,
            sender: 'useRealTimeChatCoordinator.useEffect'
        });
    }, []);
    return {
        isActive,
        isRecording,
        isConnected,
        isMuted,
        messages,
        marker,
        mediaStream,
        startChat,
        stopChat,
        toggleMute,
        setMarker
    };
}
exports.useRealTimeChatCoordinator = __webpack_exports__.useRealTimeChatCoordinator;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "useRealTimeChatCoordinator"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
